<template>
    <v-card outlined max-width="650px" class="mx-auto pa-6 pa-sm-10 mt-6 mb-12 border-top-left-radius:0; border-top-right-radius:0;">
        <div v-if="loaded">
            <div class="d-flex align-center">
                <v-icon size="18" color="green" class="mr-3">fa-check</v-icon>
                <div class="title green--text">Subscribed</div>
            </div>
            <div class="headline font-weight-medium primary--text mt-4">
                Welcome, 3 Stepper!
            </div>
            <div class="mt-2">
                    Your Monthly Subscription to the <span class="font-weight-medium">3 Steps Online World</span> has been successfully activated.
            </div>
            <v-divider class="mt-5 mb-3"></v-divider>
            <div class="body-2 font-weight-medium">
                You will be receiving an email with further information and instructions.
            </div>
            <div class="caption">
                If you have any questions you contact us at: support@3stepstocollege.com
            </div>
        </div>
        
        <SendingLoader v-else />

        <img src="https://event.webinarjam.com/t/sale/voyp7cvto?price=12.99" style="visibility:hidden; height:0px; width:0px; border:none;">
    </v-card>
</template>

<script>
import Subscription from  '@/firebase/subscription'

export default {
    data: () => ({
        loaded: false
    }),
    mounted() {
        let url = new URL(window.location.href);
        this.sessionId = url.searchParams.get('session_id');
        this.$gtm.trackView('SuccessSubscription', '/success-subscription');
        this.init();
    },
    methods: {
        init() {
            Subscription.getAcceptedSubscriber(this.$route.params.id)
                .then(response => {
                    if (response.status === true) {
                        if (response.query.empty == false) {
                            this.loaded = true;
                        } else {
                            this.$router.push('/subscription');
                        }
                    } else {
						this.$store.dispatch('setSnack', {kind:'error', text:'Error.'});
                    }
                });
        }
    }
}
</script>